var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgZapier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.043 12.488h-8.449l5.937-5.936c-.456-.685-.913-1.142-1.37-1.827a13.062 13.062 0 01-1.827-1.599L17.4 9.063V.843a7.763 7.763 0 00-2.284-.228 7.033 7.033 0 00-2.284.228v8.45L6.666 3.126c-.709.406-1.33.95-1.827 1.598-.457.685-1.142 1.142-1.598 1.827l5.936 5.936H.957L.73 14.772c-.05.768.028 1.54.228 2.283h8.45L3.242 23.22a12.24 12.24 0 003.424 3.425l5.937-5.937v8.45a7.767 7.767 0 002.284.227c.768.05 1.54-.027 2.283-.228V20.71l5.936 5.937a6.164 6.164 0 001.827-1.598 13.068 13.068 0 001.598-1.827l-5.937-5.937h8.45A7.764 7.764 0 0029.271 15a8.562 8.562 0 00-.228-2.512zM18.54 14.772a11.574 11.574 0 01-.457 2.968 6.852 6.852 0 01-2.968.457 11.579 11.579 0 01-2.969-.457 6.852 6.852 0 01-.457-2.968c.023-1.005.177-2.003.457-2.969a6.85 6.85 0 012.969-.457c1.005.023 2.003.177 2.968.457.264.97.417 1.965.457 2.969z",
    fill: "#fff"
  })));
}

export default SvgZapier;